import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 407.436 407.436" {...props}><path d="M203.718 91.567L0 294.621l21.179 21.248 182.539-181.945 182.54 181.945 21.178-21.248z" /></svg>;